import { IDuplicateCaseRepository } from '../ports/outbound/IDuplicateCaseRepository';

/**
 * The counterpart to {@link ContinueCreateDuplicateCaseUseCase}: the reviewer decides not to create
 * the case that triggered the duplicate warning. Nothing goes to E-Verify, the duplicate record is
 * resolved and drops out of the review queue.
 *
 * `reason` is required by the API and lands on the audit entry. Callers pass the validated,
 * trimmed value; this layer does not re-check it.
 */
export class AbandonDuplicateCaseUseCase {
  constructor(private readonly repository: IDuplicateCaseRepository) {}

  async execute(everifyCaseDuplicateId: string, reason: string): Promise<void> {
    return this.repository.abandonDuplicateCase(everifyCaseDuplicateId, reason);
  }
}
